import { a as r } from "../internals/array-buffer-view-core.js";
import { a as i } from "../internals/array-fill.js";
import { t } from "../internals/to-big-int.js";
import { c as n } from "../internals/classof.js";
import { f as a } from "../internals/function-call.js";
import { f as s } from "../internals/function-uncurry-this.js";
import { f as o } from "../internals/fails.js";
var f = r.aTypedArray,
  e = r.exportTypedArrayMethod,
  l = s("".slice);
e("fill", function (r) {
  var s = arguments.length;
  return f(this), a(i, this, "Big" === l(n(this), 0, 3) ? t(r) : +r, s > 1 ? arguments[1] : void 0, s > 2 ? arguments[2] : void 0);
}, o(function () {
  var r = 0;
  return new Int8Array(2).fill({
    valueOf: function valueOf() {
      return r++;
    }
  }), 1 !== r;
}));